import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { regimesForRegister } from "routes/asset-register/controller/regimes-for-register"
import { Stack } from "@mui/material"
import { BlockClicks } from "lib/@components/block-clicks"
import { If } from "lib/@components/switch"
import { Else } from "lib/@components/else"
import { MultipleRegimesDropdown } from "./multiple-regimes-dropdown"
import { Unassigned } from "./unassigned-register"

export function RegimesForRegister() {
    const { target } = useBoundContext()
    const regimes = regimesForRegister.useResults(target.id)
    const regimeCount = regimes?.length ?? 0

    return (
        <Stack direction="row" alignItems="center" sx={{ width: "100%" }}>
            <If truthy={regimeCount < 1}>
                <Unassigned />
                <Else>
                    <BlockClicks sx={{ display: "inline-flex", maxWidth: "100%", minWidth: 0 }}>
                        <MultipleRegimesDropdown regimes={regimes} regimeCount={regimeCount} />
                    </BlockClicks>
                </Else>
            </If>
        </Stack>
    )
}
